<template>
	<div class="agree-bg">
		<div class="main-xieyi-content">
			<div class="main-xieyi-title">注册协议</div>
			<div class="main-xieyi-pcontent">
				<p class="p-title">1.提示条款</p>
				<p class="p-content">各条款标题仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。</p>
				<p class="p-content">
					本协议由网络用户与智慧生活10000号共同缔结，具有合同效力。协议签约的另一方称为“用户”或“您”。在使用智慧生活10000号服务之前，您应当认真阅读并遵守《智慧生活10000号注册协议》（以下简称“本协议”），请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、争议解决和法律适用条款。如您对协议有任何疑问的，应向智慧生活10000号客服咨询。
				</p>
				<p class="p-content">
					当您在注册程序过程中按照提示提示填写信息、阅读并同意本协议并按照注册程序成功注册为智慧生活10000号用户即表示您完全接受本协议的全部条款，或您以其他智慧生活10000号允许的方式实际使用智慧生活10000号服务时，即表示您已充分阅读、理解并接受本协议的全部内容，并与智慧生活10000号达成协议。您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容或者未获得智慧生活10000号对您问询的解答等理由，主张本协议无效或本协议中的某些条款无效，或不遵守本协议约定。
				</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">2.协议范围</p>
				<p class="p-content">2.1本协议由您与智慧生活10000号共同缔结，本协议具有合同效力。</p>
				<p class="p-content">2.2除另行明确声明外，智慧生活10000号服务包含任何智慧生活10000号提供的基于互联网以及移动网的相关服务，且均受本协议约束。如果您不同意本协议的约定，您应立即停止注册/激活程序或停止使用智慧生活10000号服务。
				</p>
				<p class="p-content">
					2.3本协议内容包括协议正文、法律声明及所有智慧生活10000号已经发布或将来可能发布的各类规则、公告或通知（以下合称“网站公约”或“公约”）。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。</p>
				<p class="p-content">2.4
					随着国家法律法规和相关政策的不断更迭、完善，智慧生活10000号有权根据需要不时制订、修改、扩充本协议或各类规则，并以适当的方式向用户提示或公示。变更后的协议和规则一经在网站公示、公布后，立即或在公告明确的特定时间自动生效。若您在前述变更公告后继续使用智慧生活10000号服务的，即表示您已经阅读、理解并接受经修订的协议和规则。若您不同意相关变更，应当立即停止使用智慧生活10000号服务。
				</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">3.账户注册与使用</p>
				<p class="p-content">3.1用户注册是指用户登录智慧生活10000号，并按要求填写相关信息并确认同意履行相关用户协议、政策声明的过程。</p>
				<p class="p-content-chid">3.1.1
					在您开始注册程序使用智慧生活10000号服务前，请确保您具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，请您务必在您的监护人仔细阅读协议内容并同意的前提下，完成注册。如您违反法律法规或协议内容，造成的一切后果由您及您的监护人承担。
				</p>
				<p class="p-content-chid">
					3.1.2当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您将获得智慧生活10000号账户（即智慧生活10000号用户ID）并成为智慧生活10000号网站用户。智慧生活10000号账户（即智慧生活10000号用户ID）的所有权归智慧生活10000号，用户完成注册申请手续后，获得智慧生活10000号账号的使用权。
				</p>
				<p class="p-content-chid">
					3.1.3您需确定您使用的登陆手机、qq账号及微信账号均为本人所拥有的账号，保证注册信息的真实性。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，智慧生活10000号不负任何责任。您应当对其您帐号进行的所有活动和事件负法律责任。
				</p>
				<p class="p-content-chid">3.1.4作为智慧生活10000号经营者，为使您更好地使用智慧生活10000号的各项服务，保障您的帐号安全，智慧生活10000号可要求您按智慧生活10000号要求及我国法律规定完成实名认证。</p>
				<p class="p-content-chid">
					3.1.5由于您的智慧生活10000号账户关联您的个人信息及智慧生活10000号商业信息，您的智慧生活10000号账户仅限您本人使用。未经智慧生活10000号同意，您不得直接或间接授权第三方使用您的智慧生活10000号账户或获取您账户下信息，因此给智慧生活10000号造成的所有损失（包括但不限于直接损失、间接损失及维权支付的律师费用、保全费用、公证费用等合理开支）由您承担。智慧生活10000号有权冻结您的账户，并不予退还未使用的VIP权限。如智慧生活10000号判断您账户的使用可能危及您的账户安全及/或智慧生活10000号信息安全的，智慧生活10000号可拒绝提供相应服务或终止本协议。根据国家法律法规规定，您的用户名称和头像不能涉及官媒、党政、外国元首、色情、传播暴恐、封建迷信、分裂国家、恶意广告等违法信息，亦不能损害公共利益或第三方利益，否则智慧生活10000号有权要求您进行修改或者限制您的账号使用。如您发现本人账号遭他人非法使用，应立即通知智慧生活10000号。因黑客行为或您的保管疏忽或不当导致帐号、密码遭他人非法使用，由您或非法使用人承担责任，智慧生活10000号不承担任何责任。
				</p>
				<p class="p-content-chid">
					3.1.6由于用户帐号已关联用户信用，仅当有法律明文规定、司法文书确认或经智慧生活10000号同意，并符合智慧生活10000号规则规定的用户帐号转让流程的情况下，您可进行帐号的转让。您的帐号一经转让，该帐号项下权利义务一并转移。除此外不得以任何方式转让、赠与、外借、出租或售卖您的智慧生活10000号帐号，否则智慧生活10000号有权追究您的违约责任，且由此产生的一切责任均由您承担。
				</p>
				<p class="p-content">
					3.2智慧生活10000号赋予每个帐号在满足一定条件的情况下，通过网站正式程序下载作品的资格，但作为网站管理者，有权为保护帐号安全以及网站运营规则，同时给予一定的下载限制（如对同一时间点或某一时间段连续、高频、大量下载行为进行暂时限制下载），而不因此承担法律责任。智慧生活10000号向用户提供申诉途径，但智慧生活10000号有权根据该使用者的具体情况，自主决定是否开放下载限制。
				</p>

				<p class="p-content">3.3注册信息管理</p>
				<p class="p-content-chid">
					3.3.1您同意并授权，为了更好的为您提供服务以及确保您的账户安全，智慧生活10000号可以根据您提供的手机号码、身份证号码等信息，向全国公民身份号码查询服务中心、电信运营商、金融服务机构等可靠单位发起用户身份真实性、用户征信记录、用户手机号码有效性状态等情况的查询。
				</p>
				<p class="p-content-chid">
					3.3.2您应当向智慧生活10000号提供真实准确的注册信息，包括但不限于真实姓名、身份证号、联系电话、地址、电子邮箱、QQ或MSN、邮政编码等，保证智慧生活10000号可以通过上述联系方式与您进行联系。同时，您也应当保证不以他人资料或虚假资料在智慧生活10000号网站进行注册或身份认证，并在相关资料实际变更时及时更新有关注册资料，如因您提供他人资料、虚假资料、过期资料、非法资料等资料或未及时更新资料而造成智慧生活10000号损失的，您应对此负责并承担全额赔偿责任。
				</p>
				<p class="p-content-chid">
					3.3.3您所设置的账户名（昵称）请勿使用敏感词汇（包括但不限于：不雅不当词汇、涉及政治的词汇以及含有智慧生活10000号、智慧生活10000相关词汇），否则智慧生活10000号可对您的账户名进行暂停使用或注销等处理，并向主管机关报告。您理解并承诺，您的账户名称、头像和简介等注册信息中不得出现违法和不良信息，没有冒用、关联机构或社会名人，您在账户注册过程中需遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。
				</p>
				<p class="p-content-chid">3.3.4
					您应当及时更新您提供的信息，在法律有明确规定要求智慧生活10000号对部分用户的信息进行核实的情况下，智慧生活10000号将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整的信息。如智慧生活10000号按您最后一次提供的信息与您联系未果，您未按照智慧生活10000号的要求及时提供信息，您提供的信息存在明显不实的，您将承担因此对您自身、他人及智慧生活10000号造成的全部损失与不利后果。
				</p>

				<p class="p-content">3.4账户安全规范</p>
				<p class="p-content-chid">3.4.1您的账户为您自行设置并由您保管。建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开智慧生活10000号。</p>
				<p class="p-content-chid">3.4.2 账户因您主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，均由您个人承担。</p>
				<p class="p-content-chid">3.4.3
					您的账户只限您本人使用，不得出借或分享他人使用。当您的账户遭到未经授权的使用时，您应当立即通知智慧生活10000号，否则未经授权的使用行为均视为您本人的行为，您将自行承担所有由此导致的损失及后果。</p>

				<p class="p-content"> 3.5
					除智慧生活10000号存在过错外，您应对您账户下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。如发现任何未经授权使用您账户登录智慧生活10000号或其他可能导致您账户遭窃、遗失的情况，建议您立即通知智慧生活10000号。您理解智慧生活10000号对您的任何请求采取行动均需要合理时间，除智慧生活10000号存在过错外，智慧生活10000号对在采取行动前已经产生的后果不承担任何责任。
				</p>

				<p class="p-content">3.6 账号独立</p>
				<p class="p-content-chid">3.6.1 同一主体拥有的QQ账号及微信账号，在进行智慧生活10000号VIP登录时，将被识别为两个独立的账号。</p>
				<p class="p-content-chid">3.6.2 同一主体拥有多个QQ账号并进行智慧生活10000号VIP会员登录的，每一个QQ账号将被识别为一个独立的账号。</p>
				<p class="p-content-chid">3.6.3 同一主体拥有多个微信账号并进行智慧生活10000号VIP会员登录的，每一个微信账号将被识别为一个独立的账号。</p>
				<p class="p-content-chid">3.6.4
					每个账号之间的充值记录、VIP权限无法进行转移、迁徙、转让、赠与、售卖、租借、分享，无论该等账号是否由同一使用人拥有，请您在登录/充值/参加活动时注意区分，避免造成损失。由此造成的损失由VIP会员自行承担。</p>

				<p class="p-content">3.7 会员服务售后</p>
				<p class="p-content-chid">3.7.1 您知悉并确认，开通会员服务后，若您中途主动取消服务或终止资格或被智慧生活10000号根据本协议及相关规则注销账号、终止会员资格的，您已支付的会员服务费用将不予退还。</p>
				<p class="p-content-chid">3.7.2 如您有其他与会员服务售后相关的问题，可以通过智慧生活10000号公布的联系方式联系客服进行反馈。</p>
			</div>


			<div class="main-xieyi-pcontent">
				<p class="p-title"> 4.智慧生活10000号的服务及规范</p>
				<p class="p-content">智慧生活10000号向您提供包括但不限于以下服务：</p>
				<p class="p-content-chid">4.1.1智慧生活10000号网站服务。</p>
				<p class="p-content-chid">4.1.2智慧生活10000号（付费）会员服务（以下简称“会员服务”）；
					对于收费的网络服务，智慧生活10000号会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付并完成支付相关费用，用户才能使用该等收费网络服务，否则智慧生活10000号有权不向用户提供该等收费网络服务。</p>
				<p class="p-content-chid">4.1.3图片、文档上传分享服务（以下简称“内容上传服务”）。</p>
				<p class="p-content-chid">4.1.4智慧生活10000号搜索服务（以下简称“搜索服务”）。</p>
				<p class="p-content-chid">4.1.5智慧生活10000号下载服务（以下简称“下载服务”）。</p>
				<p class="p-content-chid">4.1.6智慧生活10000号经公示、授权、认可的其他技术和/或服务（以下简称“其他技术和服务”）。（以上服务统称为“智慧生活10000号服务”）。</p>

				<p class="p-content">4.2服务规范</p>
				<p class="p-content-chid">4.2.1
					您可通过智慧生活10000号服务在智慧生活10000号上传、发布或传输相关内容，包括但不限于文字、软件、程序、图形、图片、声音、音乐、视频、音视频、链接等信息或其他资料（下称“内容”），但您需对此内容承担相关的法律责任。</p>
				<p class="p-content-chid">4.2.2
					鉴于智慧生活10000号平台提供的服务属于电子公告牌（BBS）性质，智慧生活10000号平台上的作品内容信息均由用户自行提供并上传，由用户对其提供并上传的所有信息承担相应法律责任。智慧生活10000号平台转载作品（包括论坛内容）出于传递更多信息之目的，并不意味智慧生活10000号赞同其观点或已经证实其内容的真实性。
				</p>
				<p class="p-content-chid">4.2.3
					除非有相反证明，智慧生活10000号将您视为您在智慧生活10000号上传、发布或传输的内容的原始著作权人。您需保证对上传作品应拥有完整的所有的权利，同时保证上传的作品不会侵犯任何第三方的相关权利，包括但不限于著作权、专利权、商标权、商业秘密、隐私权、名誉权、肖像权、或其它在先权利。如有违反，您自行承担所有的法律责任（包括承担智慧生活10000号因此产生的损失）。
				</p>
				<p class="p-content-chid">4.2.4
					您使用智慧生活10000号服务上传、发布或传输内容即代表了您有权且同意在全世界范围内，永久性的、不可撤销地授予智慧生活10000号对该内容的存储、使用、修改、复制、发行、展览、网络传播、改编、出版、翻译、汇编、演绎等权利；将内容的全部或部分编入其他任何形式的作品、媒体、技术中的权利；对您的上传、发布的内容进行商业开发的权利；通过有线或无线网络向计算机终端、移动通讯终端（包括但不限于便携式通讯设备如手机和智能平板电脑等）、手持数字影音播放设备、电视接收设备（模拟信号接收设备、数字信号接收设备、数字电视、IPTV、带互联网接入功能的播放设备等）等提供信息的下载、数据传输、及其相关的宣传和推广等服务的权利；再授权给其他第三方以上述方式使用的权利；以及对作品进行单独维权的权利。

				</p>
				<p class="p-content">
					您同意在使用我方平台服务过程中，遵守相关法律法规及司法解释，包括但不限于《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》等。在任何情况下，一旦我方合理地认为您的行为可能违反上述法律、法规，可以在任何时候，不经事先通知终止向您提供服务。
				</p>

				<p class="p-content">4.3 服务变更、中断或终止</p>
				<p class="p-content-chid">4.3.1
					鉴于网络服务的特殊性，用户同意智慧生活10000号有权随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。如变更、中断或终止的网络服务属于免费网络服务，智慧生活10000号无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的网络服务属于收费网络服务，智慧生活10000号应当在变更、中断或终止之前事先通知用户。
				</p>
				<p class="p-content-chid">4.3.2
					用户理解，智慧生活10000号需要定期或不定期地对提供网络服务的平台（如互联网网站）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，智慧生活10000号无需为此承担任何责任，但智慧生活10000号应尽可能事先进行通告。</p>
				<p class="p-content-chid">4.3.3 如发生下列任何一种情形，智慧生活10000号有权随时中断或终止向用户提供本协议项下的网络服务（包括收费网络服务）而无需对用户或任何第三方承担任何责任：</p>
				<p class="p-content-chid">1） 用户提供的个人资料不真实。</p>
				<p class="p-content-chid">2） 用户违反本协议中规定的使用规则。</p>
				<p class="p-content-chid">3） 用户在使用收费网络服务时未按规定向智慧生活10000号支付相应的服务费。</p>

				<p class="p-content">4.4 其他服务规范</p>
				<p class="p-content-chid">
					4.4.1为方便您使用智慧生活10000号和智慧生活10000号关联公司的其他相关服务，您授权智慧生活10000号将您在账户注册和使用智慧生活10000号服务过程中提供、形成的信息传递给智慧生活10000号关联公司等其他相关服务提供者，或从智慧生活10000号关联公司等其他相关服务提供者获取您在注册、使用相关服务期间提供、形成的信息。
				</p>
				<p class="p-content-chid">
					4.4.2您理解并知晓在使用智慧生活10000号服务时，所接触的内容和信息来源广泛，智慧生活10000号无法对该内容和信息的准确性、真实性、可用性、安全性、完整性和正当性负责。您理解并认可您可能会接触到不正确的、令人不快的、不适当的或令人厌恶的内容和信息，您不会以此追究智慧生活10000号的相关责任。智慧生活10000号不对用户在智慧生活10000号上传、发布或传输的任何内容和信息背书、推荐或表达观点，也不对任何内容和信息的错误、瑕疵及产生的损失或损害承担任何责任，您对内容和信息的任何使用需自行承担相关的风险。
				</p>
				<p class="p-content-chid">
					4.4.3您同意智慧生活10000号在提供服务的过程中以各种方式投放商业性广告或其他任何类型的商业信息（包括但不限于在智慧生活10000号的任何位置上投放广告，在您上传、传播的内容中投放广告），您同意接受智慧生活10000号通过电子邮件、站内短信、手机短信、网站公告或其他方式向您发送促销或其他相关商业信息。
				</p>

				<p class="p-content">4.5 使用规则</p>
				<p class="p-content-chid">用户在使用智慧生活10000号网络服务过程中，必须遵循以下原则：</p>
				<p class="p-content-chid">4.5.1 遵守中国有关的法律和法规。</p>
				<p class="p-content-chid">4.5.2 遵守所有与智慧生活10000号网络服务有关的网络协议、规定和程序。</p>
				<p class="p-content-chid">4.5.3 不得为任何非法目的而使用网络服务系统。</p>
				<p class="p-content-chid">4.5.4 不得利用智慧生活10000号网络服务系统进行任何可能对互联网正常运转造成不利影响的行为。</p>
				<p class="p-content-chid">4.5.5 不得利用智慧生活10000号提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料。</p>
				<p class="p-content-chid">4.5.6 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权、肖像权、隐私权、物权或其他任何合法权益。</p>
				<p class="p-content-chid">4.5.7 不得利用智慧生活10000号网络服务系统进行任何不利于智慧生活10000号的行为。</p>
				<p class="p-content-chid">4.5.8 如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告智慧生活10000号。</p>
				<p class="p-content-chid">4.5.9
					网络用户下载智慧生活10000号的作品，应在作品的授权许可范围内使用。未经版权拥有者许可，仅限学习交流使用，请勿做他用，若用户用做他用的，追究该用户的法律责任。同时，作品下载使用者遵守著作权法及其他相关法律的规定，不得侵害本网站及权利人的合法权利。
				</p>
				<p class="p-content-chid">4.5.10
					用户账号信息（包括但不限于头像、昵称等）完全来源于用户自行上传或填写，若智慧生活10000号发现用户账号信息存在侵犯第三方权利、违反相关法律法规规定或违背公序良俗的情况，智慧生活10000号将采取例如强制删除用户账号信息中的违规部分等措施以杜绝违规部分的传播，因用户账号信息违规导致的侵权投诉或行政处罚，将由用户承担全部责任，对智慧生活10000号造成的损失应一并赔偿。
				</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title"> 5.费用</p>
				<p class="p-content"> 5.1智慧生活10000号为向您提供的服务付出了大量的成本，智慧生活10000号有权根据智慧生活10000号相关规则向您收取一定费用作为网站维护的费用。</p>
				<p class="p-content"> 5.2
					退款。若您已使用下载服务，因提供下载服务的特殊性，一经下载文件将会储存于您的电脑，代表您已经使用该服务，除文件本身损坏导致不可用的情况外，一律不接受退款申请。未使用下载服务的情况下，智慧生活10000号接受无理由退款申请。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title"> 6.隐私保护</p>
				<p class="p-content"> 6.1 保护用户隐私是智慧生活10000号的一项基本政策，智慧生活10000号保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在智慧生活10000号的非公开内容，但下列情况除外：</p>
				<p class="p-content-chid">6.1.1 事先获得用户的明确授权；</p>
				<p class="p-content-chid">6.1.2 根据有关的法律法规要求；</p>
				<p class="p-content-chid">6.1.3 按照相关政府主管部门的要求；</p>
				<p class="p-content-chid">6.1.4 为维护社会公众的利益；</p>
				<p class="p-content-chid">6.1.5 为维护智慧生活10000号的合法权益。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title"> 7.免责声明</p>
				<p class="p-content"> 7.1 用户明确同意其使用智慧生活10000号网络服务所存在的风险将完全由其自己承担；因其使用智慧生活10000号网络服务而产生的一切后果也由其自己承担，智慧生活10000号对用户不承担任何责任。</p>
				<p class="p-content"> 7.2 智慧生活10000号不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。</p>
				<p class="p-content"> 7.3 智慧生活10000号不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由智慧生活10000号实际控制的任何网页上的内容，智慧生活10000号不承担任何责任。</p>
				<p class="p-content"> 7.4 对于因不可抗力或智慧生活10000号不能控制的原因造成的网络服务中断或其它缺陷，智慧生活10000号不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</p>
				<p class="p-content"> 7.5 用户同意，对于智慧生活10000号向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，智慧生活10000号无需承担任何责任。</p>
				<p class="p-content-chid">7.5.1 智慧生活10000号向用户免费提供的各项网络服务；</p>
				<p class="p-content-chid">7.5.2 智慧生活10000号向用户赠送的任何产品或者服务；</p>
				<p class="p-content-chid">7.5.3 智慧生活10000号向收费网络服务用户附赠的各种产品或者服务。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title"> 8.违约赔偿</p>
				<p class="p-content">8.1如因智慧生活10000号违反有关法律、法规或本协议项下的任何条款而给用户造成损失，智慧生活10000号同意承担由此造成的损害赔偿责任。</p>
				<p class="p-content">
					8.2用户同意保障和维护智慧生活10000号及其他用户的利益，如因以下情形给智慧生活10000号及其关联方或任何第三方造成损失，用户同意承担由此造成的损害赔偿责任（包括但不限于智慧生活10000对外承担的赔偿费用、为此支出的律师费用、诉讼费、仲裁费、差旅费等其它合理开支）：
				</p>
				<p class="p-content-chid">1）用户或使用用户帐号的其他人违反有关法律、法规或本协议项下的任何条款；</p>
				<p class="p-content-chid">2）任何第三人主张用户存在侵害著作权、商标权、专利权、商业秘密、隐私权、名誉权、公开权、肖像权、物权或其他在先权利的行为；</p>
				<p class="p-content-chid">3）违反本协议约定或违反法律法规规定的其他行为。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title"> 9.协议修改</p>
				<p class="p-content"> 9.1 智慧生活10000号有权随时修改本协议的任何条款，一旦本协议的内容发生变动，智慧生活10000号将会通过适当方式向用户提示或公示修改内容。</p>
				<p class="p-content"> 9.2 如果不同意智慧生活10000号对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受智慧生活10000号对本协议相关条款所做的修改。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">10.通知送达</p>
				<p class="p-content">10.1 本协议项下智慧生活10000号对于用户所有的通知均可通过网页公告、电子邮件或常规的信件传送等方式进行，该等通知于发送之日视为已送达收件人。</p>
				<p class="p-content"> 10.2 用户对于智慧生活10000号的通知和/或相关文书应当通过智慧生活10000号对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">11.法律管辖</p>
				<p class="p-content">11.1 本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">12. 其他规定</p>
				<p class="p-content">12.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
				<p class="p-content">12.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
				<p class="p-content">12.3 本协议中的标题仅为方便而设，智慧生活10000号和用户的权利义务以协议内容为准。</p>
			</div>

			<div class="main-xieyi-pcontent" style="margin-bottom:45px;">
				<p class="p-title">联系方式：</p>
				<p class="p-content">客服邮箱</p>
				<p class="p-content">{{ getQQService }}@qq.com</p>
				<p class="p-content">在线客服</p>
				<p class="p-content"> QQ：{{ getQQService }}（周一到周五：9:00-18:00）</p>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters(["getQQService"]),
    },
	};
</script>
<style scoped>
	.agree-bg {
		width: 100%;
		background: #F4F4F4;
		overflow: hidden;
		display: flex;
		justify-content: center;
	}

	.main-xieyi-content {
		width: 995px;
		background: #fff;
		float: left;
		margin-left: 20px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.main-xieyi-title {
		margin-left: 25px;
		margin-top: 45px;
		font-size: 16px;
		color: #4A4A4A;
		margin-right: 25px;
		font-weight: bold;
	}

	.main-xieyi-pcontent p {
		margin-left: 25px;
		margin-right: 25px;
	}

	.p-content {
		font-size: 14px;
		color: #888888;
		margin-bottom: 20px;
		line-height: 22px;
	}

	.p-title {
		margin-top: 30px;
		margin-bottom: 25px;
		font-size: 14px;
		color: #4A4A4A;
		font-weight: bold;
	}

	.p-content-chid {
		font-size: 14px;
		color: #888888;
		margin-bottom: 15px;
		line-height: 22px;
	}
</style>
